import { render, staticRenderFns } from "./metrixReport.vue?vue&type=template&id=3f59c8c0"
import script from "./metrixReport.vue?vue&type=script&lang=js"
export * from "./metrixReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports